import { render, staticRenderFns } from "./myCourse.vue?vue&type=template&id=484780ea&scoped=true&"
import script from "./myCourse.vue?vue&type=script&lang=js&"
export * from "./myCourse.vue?vue&type=script&lang=js&"
import style0 from "./myCourse.vue?vue&type=style&index=0&id=484780ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484780ea",
  null
  
)

export default component.exports